import { ApiBase } from "@/src/model/ApiBase";
import { SLA_API_TYPE } from "@/src/model/apiTypes";

// SLA API wrapper centralizing endpoints used by SLAReport.vue
export class SLAApi extends ApiBase {
  // GET /api/monitoring/sla-config/
  async [SLA_API_TYPE.GET_CONFIG]() {
    return await this.httpGet("monitoring/sla-config/");
  }

  // GET /api/monitoring/uptime-check/ with various types
  // params: { type, range, align, checker_location, job, location, metric_id, agg, slo_name, service, slo }
  async [SLA_API_TYPE.GET_METRICS]({ params }) {
    const usp = new URLSearchParams(params || {});
    return await this.httpGet(`monitoring/uptime-check/?${usp.toString()}`);
  }

  // GET /api/jsm/incidents/count/
  // params: { range, jql }
  async [SLA_API_TYPE.GET_INCIDENTS_COUNT]({ params }) {
    const usp = new URLSearchParams(params || {});
    return await this.httpGet(`jsm/incidents/count/?${usp.toString()}`);
  }
}
